<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
export default{
  methods:{
    _isMobile() {
	    let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag;
    }
  },
  mounted(){
     if (this._isMobile()) {
      console.log("手机端");
      // document.documentElement.style.fontSize = document.documentElement.clientWidth/3.75 + 'px';
      // this.$router.replace('/m_home');
      window.location.href = 'https://m.ncmps.com'
    } else {
      console.log("pc端");
      // this.$router.replace('/');
    }
  }
}
</script>
<style>

</style>
